module.exports = __webpack_public_path__ + "static/nodata.81975a4f.png";